import { render, staticRenderFns } from "./SummaryLengkap.vue?vue&type=template&id=4c95c716&scoped=true"
import script from "./SummaryLengkap.vue?vue&type=script&lang=js"
export * from "./SummaryLengkap.vue?vue&type=script&lang=js"
import style0 from "./SummaryLengkap.vue?vue&type=style&index=0&id=4c95c716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c95c716",
  null
  
)

export default component.exports